import angular from 'angular';
import dashboardContainer from './dashboardContainer';

export default angular.module('businessPlanningDashboard.scenes', [
  dashboardContainer,
]).name;
